// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"46630fed","892":"96596df7"}[chunkId] + ".chunk.js";
};